import React, { useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";

const API_URL = "https://api.ricgop.online/api/v1/company";
const TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTQ0MCwiZW1haWwiOiJpbmZvQHJpY2dvcC5vbmxpbmUiLCJuYW1lIjoiTXIgV2Vic2l0ZSIsImlhdCI6MTc2NjQ2ODI1Nn0.xjOAl33RTZCkiqDrPeRE1E_ruLlpFaCQjEF7CMKfCsY";

const RegisterCompany = () => {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
    website: "",
    cell: "",
    user1: { name: "", cnic: "", cellNumber: "", userName: "" },
    user2: { name: "", cnic: "", cellNumber: "", userName: "" }
  });

  const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "success" });
  const [saving, setSaving] = useState(false); 

  const handleChange = (e, userKey = null) => {
    const { name, value } = e.target;

    if (userKey) {
      setFormData({
        ...formData,
        [userKey]: { ...formData[userKey], [name]: value }
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const showSnackbar = (message, type = "success") => {
    setSnackbar({ open: true, message, type });
    // Auto-hide after 3 seconds
    setTimeout(() => {
      setSnackbar({ open: false, message: "", type });
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSaving(true);
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        showSnackbar(data.message || "An error occurred", "error");
        setSaving(false);
        return;
      }

      showSnackbar("✅ Company Registered Successfully", "success");

      // Reset form
      setFormData({
        name: "",
        address: "",
        phone: "",
        email: "",
        website: "",
        cell: "",
        user1: { name: "", cnic: "", cellNumber: "", userName: "" },
        user2: { name: "", cnic: "", cellNumber: "", userName: "" }
      });
      e.target.reset();
    } catch (err) {
      console.error(err);
      showSnackbar("An unexpected error occurred", "error");
    }
    setSaving(false);
  };

  return (
    <main>
      <Breadcrumb title="Register Your Company" />

      {/* Snackbar at the top */}
      {snackbar.open && (
        <div
          style={{
            position: "fixed",
            top: 20,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: snackbar.type === "success" ? "#4caf50" : "#f44336",
            color: "#fff",
            padding: "12px 24px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            zIndex: 9999,
            transition: "all 0.3s ease-in-out"
          }}
        >
          {snackbar.message}
        </div>
      )}

      <section className="py-5" style={{ backgroundColor: "#f9fbfc" }}>
        <div className="container">
          <h2 className="text-center mb-5 text-dark fw-bold display-5">
            🏢 Company Registration
          </h2>
          <div>
  <h4 className="text-center mb-5 text-dark">
    For Login Please{" "}
    <a
      href="https://app.ricgop.online"
      style={{ color: "red", textDecoration: "none" }}
    >
      Click Here
    </a>
  </h4>
</div>
<br />

          <form onSubmit={handleSubmit}>
            {/* Company Info */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-header bg-transparent p-4">
                <h5 className="fw-semibold text-primary mb-0">
                  📄 Company Information
                </h5>
              </div>
              <div className="card-body p-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Company Name" name="name" onChange={handleChange} required/>
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Address" name="address" onChange={handleChange} required/>
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Phone" name="phone" onChange={handleChange} required/>
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Cell" name="cell" onChange={handleChange} required/>
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Email" name="email" onChange={handleChange} required/>
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Website" name="website" onChange={handleChange} required/>
                  </div>
                </div>
              </div>
            </div>

            {/* User 1 */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-header bg-transparent p-4">
                <h5 className="fw-semibold text-primary mb-0">👤 Authorized User 1</h5>
              </div>
              <div className="card-body p-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Name" name="name" onChange={(e) => handleChange(e, "user1")} />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="CNIC" name="cnic" onChange={(e) => handleChange(e, "user1")} />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Cell Number" name="cellNumber" onChange={(e) => handleChange(e, "user1")} />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Username" name="userName" onChange={(e) => handleChange(e, "user1")} />
                  </div>
                </div>
              </div>
            </div>

            {/* User 2 */}
            <div className="card border-0 shadow-sm rounded-4 mb-4">
              <div className="card-header bg-transparent p-4">
                <h5 className="fw-semibold text-primary mb-0">👤 Authorized User 2</h5>
              </div>
              <div className="card-body p-4">
                <div className="row g-3">
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Name" name="name" onChange={(e) => handleChange(e, "user2")} />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="CNIC" name="cnic" onChange={(e) => handleChange(e, "user2")} />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Cell Number" name="cellNumber" onChange={(e) => handleChange(e, "user2")} />
                  </div>
                  <div className="col-md-6">
                    <input className="form-control" placeholder="Username" name="userName" onChange={(e) => handleChange(e, "user2")} />
                  </div>
                </div>
              </div>
            </div>

            {/* Submit */}
            <div className="text-center">
              <button type="submit" className="btn btn-danger rounded-pill px-5 py-3" >
 {saving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Submitting...
                  </>
                ) : (
                  "Submit Registration"
                )}              </button>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
};

export default RegisterCompany;
